import { Injectable, EventEmitter } from '@angular/core';
import { NotificationEvent, SaleRequestNotificationDto, StudySubmittedNotificationDto, DownloadStatusNotificationDto } from '../../models/common/notification-event.model';
import { UserProfileModel } from '../../models/repository/user-profile.model';
import { SaleHorse } from '../../models/sales/sale-horse.model';
import { SaleSubmissions } from '../../models/sales/sales.model';
import { StudyFileUpload } from '../../models/Study/study-file.model';

@Injectable({
  providedIn: 'root',
})
export class EventsEmitter {
  public topBannerEvent: EventEmitter<UserProfileModel> = new EventEmitter<UserProfileModel>();
  public fileStartUploadEvent: EventEmitter<StudyFileUpload[]> = new EventEmitter<StudyFileUpload[]>();
  public fileUploadDataSavedEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  public updateStudyFileStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  public fileUploadCompleteEvent: EventEmitter<any> = new EventEmitter<any>();
  public updateSaleHorseEvent: EventEmitter<SaleHorse> = new EventEmitter<SaleHorse>();
  public updateSaleHorseSubmissionEvent: EventEmitter<SaleSubmissions> = new EventEmitter<SaleSubmissions>();
  public onNotificationSelectionChangeEvent: EventEmitter<any[]> = new EventEmitter<any[]>();
  public onStudyPopupCloseEvent: EventEmitter<number> = new EventEmitter<number>();
  public onSaleRequestApproveEvent: EventEmitter<number> = new EventEmitter<number>();
  public onSaleRequestDeniedEvent: EventEmitter<number> = new EventEmitter<number>();
  public onSaleRequestApproveOrDeniedEvent: EventEmitter<void> = new EventEmitter<void>();
  public onStudySubmitted: EventEmitter<NotificationEvent<StudySubmittedNotificationDto>> = new EventEmitter<NotificationEvent<StudySubmittedNotificationDto>>();
  public onSaleRequested: EventEmitter<NotificationEvent<SaleRequestNotificationDto>> = new EventEmitter<NotificationEvent<SaleRequestNotificationDto>>();
  public onSaleResult: EventEmitter<NotificationEvent<any>> = new EventEmitter<NotificationEvent<any>>();
  public onDownloadStatusUpdate: EventEmitter<NotificationEvent<DownloadStatusNotificationDto>> = new EventEmitter<NotificationEvent<DownloadStatusNotificationDto>>();
  public onDownloadComplete: EventEmitter<NotificationEvent<DownloadStatusNotificationDto>> = new EventEmitter<NotificationEvent<DownloadStatusNotificationDto>>();
  public onDownloadError: EventEmitter<NotificationEvent<DownloadStatusNotificationDto>> = new EventEmitter<NotificationEvent<DownloadStatusNotificationDto>>();
  public onDownloadCancelled: EventEmitter<NotificationEvent<DownloadStatusNotificationDto>> = new EventEmitter<NotificationEvent<DownloadStatusNotificationDto>>();

  public completeBatchIds: string[] = [];

  emitTopBannerEvent(data: UserProfileModel) {
    this.topBannerEvent.emit(data);
  }
  emitFileStartUploadEvent(files: StudyFileUpload[]) {
    this.fileStartUploadEvent.emit(files);
  }
  emitFileUploadDataSavedEvent() {
    this.fileUploadDataSavedEvent.emit(true);
  }

  emitFileUploadCompleteEvent(data: any) {
    if (!this.completeBatchIds.includes(data.batchId)) {
      this.completeBatchIds.push(data.batchId);
      this.fileUploadCompleteEvent.emit(data);
    }
  }

  emitNotificationSelectionChange(recipients: any[]) {
    this.onNotificationSelectionChangeEvent.emit(recipients);
  }

  emitUpdateStudyFileStatus() {
    this.updateStudyFileStatus.emit(true);
  }
  emitUpdateSaleHorseSubmission(submission: SaleSubmissions) {
    this.updateSaleHorseSubmissionEvent.emit(submission);
  }
  emitUpdateSaleHorse(saleHorse: SaleHorse) {
    this.updateSaleHorseEvent.emit(saleHorse);
  }

  emitOnStudyPopupCloseEvent(saleId: number) {
    this.onStudyPopupCloseEvent.emit(saleId);
  }
  emitOnSaleRequestApproveEvent(saleId: number) {
    this.onSaleRequestApproveEvent.emit(saleId);
  }
  emitOnSaleRequestDeniedEvent(saleId: number) {
    this.onSaleRequestDeniedEvent.emit(saleId);
  }
  emitOnSaleRequestApproveOrDeniedEvent() {
    this.onSaleRequestApproveOrDeniedEvent.emit();
  }
  emitOnStudySubmitted(notification: NotificationEvent<StudySubmittedNotificationDto>) {
    this.onStudySubmitted.emit(notification);
  }
  emitOnSaleRequested(notification: NotificationEvent<SaleRequestNotificationDto>) {
    this.onSaleRequested.emit(notification);
  }
  emitOnSaleResult(notification: NotificationEvent<any>) {
    this.onSaleResult.emit(notification);
  }
  emitOnDownloadStatusUpdate(notification: NotificationEvent<DownloadStatusNotificationDto>) {
    this.onDownloadStatusUpdate.emit(notification);
  }
  emitOnDownloadComplete(notification: NotificationEvent<DownloadStatusNotificationDto>) {
    this.onDownloadComplete.emit(notification);
  }
  emitOnDownloadError(notification: NotificationEvent<DownloadStatusNotificationDto>) {
    this.onDownloadError.emit(notification);
  }
  emitOnDownloadCancelled(notification: NotificationEvent<DownloadStatusNotificationDto>) {
    this.onDownloadCancelled.emit(notification);
  }
}
